var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-filter" }, [
    _c(
      "form",
      {
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.formSubmit($event)
          }
        }
      },
      [
        _c("div", { staticClass: "grid-container" }, [
          _c("div", { staticClass: "cell" }, [
            _c(
              "label",
              {
                staticClass: "c-filter__heading",
                attrs: { for: "filter-search" }
              },
              [_vm._v(_vm._s(_vm.searchLabel || "Search by keyword:"))]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "c-filter__search" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchTerm,
                    expression: "searchTerm"
                  }
                ],
                staticClass: "c-filter__search-field",
                attrs: {
                  id: "filter-search",
                  name: "searchTerm",
                  type: "search"
                },
                domProps: { value: _vm.searchTerm },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.searchTerm = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "c-button c-button--brand",
                  attrs: { type: "submit" }
                },
                [_vm._v("\n            Search\n          ")]
              )
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b5ebc0ae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5ebc0ae","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/consumer/results/SearchFilter.vue
// module id = 618
// module chunks = 0